@let nav = item();
@if (isCollapsed()) {
  <a
    [id]="nav.id"
    [routerLink]="nav.routerLink ? [nav.routerLink] : []"
    [queryParams]="nav.queryParams"
    [routerLinkActiveOptions]="nav.routerOptions"
    [queryParamsHandling]="queryParamsHandling()"
    routerLinkActive="active"
    class="nav-menu-item nav-link text-secondary text-center"
    [ngbTooltip]="nav.label"
    placement="auto"
  >
    <cds-icon [shape]="nav.icon" sizePx="20" />
  </a>
} @else {
  <a
    [id]="nav.id"
    [routerLink]="nav.routerLink ? [nav.routerLink] : []"
    [queryParams]="nav.queryParams"
    [routerLinkActiveOptions]="nav.routerOptions"
    [queryParamsHandling]="queryParamsHandling()"
    routerLinkActive="active"
    class="nav-menu-item nav-link"
  >
    <cds-icon
      [shape]="nav.icon"
      sizePx="20"
      class="mx-2 text-secondary"
      style="vertical-align: bottom"
    />
    {{ nav.label }}
    @if (nav.new) {
      <span class="badge bg-primary ms-1 rounded-pill fw-normal" i18n>NEW</span>
    }
  </a>
}
